import { UserAttributes } from '../services/auth/types';
export type Language = 'fi' | 'en';
export interface NotificationSentAt {
    mediaMissing?: number;
    applicationTooLongInCreated?: number;
    newApplications?: number;
}
export interface OldUserInterface {
    /** create at date as Unix epoc (ms) */
    createdAt: number;
    /** user id (Cognito user sub) */
    userId: string;
    updatedAt?: number;
    language: Language;
    /** contains notification sent at dates (Unix epoc) per notifications type */
    notifSentAt?: NotificationSentAt;
    collateralVerified?: boolean;
}
/** this data is saved at registering and can be updated later */
export interface UserData {
    phoneNumber: string;
    name: string;
    language: Language;
}
export interface UpdateUserData {
    /** remove when all users documents have loginEmail */
    loginEmail: string;
    data: UserData;
}
export interface CreateUser {
    /** user id (Cognito user sub) */
    userId: string;
    /** email used to login, doesn't change */
    loginEmail: string;
    data: UserData;
    emailUnconfirmed?: boolean;
}
export interface UserInterface extends CreateUser {
    /** create at date as Unix epoc (ms) */
    createdAt: number;
    updatedAt?: number;
    /** contains notification sent at dates (Unix epoc) per notifications type */
    notifSentAt?: NotificationSentAt;
    collateralVerified?: boolean;
}
export type User = UserInterface | OldUserInterface;
/** type guard so we can check for TS if user is new or old */
export const isUserWithContactInfo = (user: User): user is UserInterface => (user as UserInterface)?.loginEmail !== undefined &&
    (user as UserInterface)?.data?.name !== undefined;
export interface CognitoUserData {
    sub?: string; // userId
    isAuthenticated: boolean;
    isConfirmingEmail: boolean;
    attributes?: UserAttributes | Record<string, never>;
    role?: string;
}
export type EmailConfirmationSituation = 'success' | 'maybeSuccess' | 'error';
export type EmailConfirmationMessageCode = 'success' | 'maybeSuccess' | 'CodeMismatchException' | 'ExpiredCodeException' | 'generalError';
export interface EmailConfirmationResult {
    situation: EmailConfirmationSituation;
    messageCode: EmailConfirmationMessageCode;
}
